<script>
    export default {
      name: 'media-fipe-table',
      props: ['comitente', 'type'],
      data () {
        return {}
      },
      computed: {
        filteredData () {
          let type = this.type
          let comitente = {
            leiloes: [],
            mediaPeriodoVendidos: this.comitente[`${type}MediaPeriodoVendidos`],
            mediaPeriodoFipe: this.comitente[`${type}MediaPeriodoFipe`]
          }

          for (var i = 0, len = this.comitente.leiloes.length; i < len; ++i) {
            let l = this.comitente.leiloes[i]
            let quantidade = Number(l[`${type}Quantidade`])
            if (quantidade === 0) {
              continue
            }

            comitente.leiloes.push({
              data: l.data,
              quantidade: l[`${type}Quantidade`],
              vendidos: l[`${type}Vendidos`],
              percentualVenda: l[`${type}PercentualVenda`],
              percentualFipe: l[`${type}PercentualFipe`]
            })
          }

          return comitente
        }
      },
      mounted () {
      },
      destroyed () {
      },
      methods: {
        an (v) {
          return Math.round(Number(v))
        },
        semAno (v) {
          return String(v.slice(0, -5))
        }
      },
      components: {}
    }
</script>

<template>
  <div class="c-result-sub">
    <h4>{{type}}</h4>
    <table class="tbl-result2">
      <tr>
        <th>Data</th>
        <th>Quantidade</th>
        <th>Vendidos</th>
        <th>% Venda</th>
        <th>% FIPE</th>
      </tr>
      <tr v-for="leilao in filteredData.leiloes">
        <td>{{semAno(leilao.data)}}</td>
        <td>{{leilao.quantidade}}</td>
        <td>{{leilao.vendidos}}</td>
        <td>{{an(leilao.percentualVenda)}}%</td>
        <td>{{an(leilao.percentualFipe)}}%</td>
      </tr>
      <tr>
        <td colspan="5" class="text-left">
          Médias mês vendidos: <strong>{{an(filteredData.mediaPeriodoVendidos)}}%</strong>
        </td>
      </tr>
      <tr>
        <td colspan="5" class="text-left">
          Médias mês FIPE: <strong>{{an(filteredData.mediaPeriodoFipe)}}%</strong>
        </td>
      </tr>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// table.vue?06ddf59e